const DAILY = 'daily';
const WEEKLY = 'weekly';
const MONTHLY = 'monthly';
const YEARLY = 'yearly';
const RECURRENCE_EVENT_KEYS = [
    'dt_until',
    'by_month_day',
    'by_year_day',
    'by_month',
    'week_index',
    'by_day',
    'recurrence',
    'freq',
];
export { DAILY, WEEKLY, MONTHLY, YEARLY, RECURRENCE_EVENT_KEYS, };
